"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Android_1 = __importDefault(require("../Icons/Android"));
var Apple_1 = __importDefault(require("../Icons/Apple"));
var Facebook_1 = __importDefault(require("../Icons/Facebook"));
var Instagram_1 = __importDefault(require("../Icons/Instagram"));
var Twitter_1 = __importDefault(require("../Icons/Twitter"));
var config = {
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.lu/registration/aboutuslogged'
                    },
                    text: 'Qui sommes-nous ?'
                },
                {
                    linkProps: {
                        href: '//www.veepee.lu/postsales/contactselector'
                    },
                    text: 'Aide et contact'
                }
            ],
            title: 'À propos de Veepee'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.lu/northdocs/lu/tos_LU.pdf',
                        target: '_blank'
                    },
                    text: 'Conditions générales'
                },
                {
                    linkProps: {
                        href: '//www.veepee.lu/northdocs/lu/PP_Veepee_LU.pdf',
                        target: '_blank'
                    },
                    text: 'Politique de confidentialité et d\'utilisation des cookies'
                }
            ],
            title: 'Information Légale'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//careers.veepee.com/en/home-page-en',
                        target: '_blank'
                    },
                    text: 'Veepee'
                },
                {
                    linkProps: {
                        href: '//careers.veepee.com/vptech-2/',
                        target: '_blank'
                    },
                    text: 'vpTech'
                }
            ],
            title: 'Rejoignez l\'équipe'
        },
        {
            items: [],
            title: ''
        }
    ],
    country: 'LU',
    flag: 'LU',
    header: {
        apps: {
            items: [
                {
                    icon: Apple_1.default,
                    label: 'iOS',
                    linkProps: {
                        href: '//apps.apple.com/be/app/veepee-by-vente-privee/id906681058',
                        target: '_blank'
                    }
                },
                {
                    icon: Android_1.default,
                    label: 'Android',
                    linkProps: {
                        href: '//play.google.com/store/apps/details?id=com.venteprivee',
                        target: '_blank'
                    }
                }
            ],
            title: 'Apps'
        },
        social: [
            {
                icon: Instagram_1.default,
                label: 'Instagram',
                linkProps: {
                    href: '//www.instagram.com/veepee_benelux/',
                    target: '_blank'
                }
            },
            {
                icon: Facebook_1.default,
                label: 'Facebook',
                linkProps: {
                    href: '//www.facebook.com/Veepee.Benelux/',
                    target: '_blank'
                }
            },
            {
                icon: Twitter_1.default,
                label: 'Twitter',
                linkProps: {
                    href: '//twitter.com/Veepee_Benelux/',
                    target: '_blank'
                }
            }
        ]
    },
    lang: 'fr',
    logoSubtitle: 'VP, grandes marques à prix discount'
};
exports.default = config;
